export default "__VITE_ASSET__I2oDhSkr__"